import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import client from '../images/client.png';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import img1 from "../images/testi/1.png";
import img2 from "../images/testi/2.png";
import img3 from "../images/testi/3.png";

export const Testimonials = () => {
    const testimonials = [
        {
            name: "Savii E Barroliya",
            role: "Vastu Expert",
            image: img1,
            comment: "Ajay & Nistha completely changed my Instagram growth. My calls and sales increased massively, and my engagement went through the roof. Now I can focus on running the business without worrying about lead and my socials."
        },
        {
            name: "Ruchi Sharmma",
            role: "Nutrition Coach",
            image: img2,
            comment: "At first, my hopes were low after a big loss with a previous agency, but I gave Alikeu a last shot. They proved with smart strategies and analysis that real growth is possible!"
        },
        {
            name: "Deepika Khattar",
            role: "Tarot & Manifestation Coach",
            image: img3,
            comment: "I’m happy I took that discovery call because I had been stuck at 90K followers for a year, but with Alikeu, I gained 45,000 followers and over 3k leads in just 90 days."
        },
        {
            name: "Savii E Barroliya",
            role: "Vastu Expert",
            image: img1,
            comment: "Ajay & Nistha completely changed my Instagram growth. My calls and sales increased massively, and my engagement went through the roof. Now I can focus on running the business without worrying about lead and my socials."
        },
        {
            name: "Ruchi Sharmma",
            role: "Nutrition Coach",
            image: img2,
            comment: "At first, my hopes were low after a big loss with a previous agency, but I gave Alikeu a last shot. They proved with smart strategies and analysis that real growth is possible!"
        },
        {
            name: "Deepika Khattar",
            role: "Tarot & Manifestation Coach",
            image: img3,
            comment: "I’m happy I took that discovery call because I had been stuck at 90K followers for a year, but with Alikeu, I gained 45,000 followers and over 3k leads in just 90 days."
        },
    ]

    const [style, setStyle] = useState({
        "--testi-width": "250px",
        "--testi-height": "270px",
        "--testi-quantity": testimonials.length
    });

    const width = window.screen.width;
    useEffect(() => {
        const updateTransformValues = () => {
            if (width >= 3700) {
                setStyle({
                    "--testi-width": "1000px",
                    "--testi-height": "450px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width > 3700 && width > 1600) {
                setStyle({
                    "--testi-width": "250px",
                    "--testi-height": "420px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width > 1600 && width > 1500) {
                setStyle({
                    "--testi-width": "350px",
                    "--testi-height": "270px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width > 1500 && width > 1400) {
                setStyle({
                    "--testi-width": "350px",
                    "--testi-height": "270px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width > 1400 && width > 1390) {
                setStyle({
                    "--testi-width": "500px",
                    "--testi-height": "240px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width < 1390 && width > 1300) {
                setStyle({
                    "--testi-width": "400px",
                    "--testi-height": "270px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width < 1300 && width > 1200) {
                setStyle({
                    "--testi-width": "380px",
                    "--testi-height": "270px",
                    "--testi-quantity": testimonials.length
                });
            } else if (width < 600 && width > 200) {
                setStyle({
                    "--testi-width": "330px",
                    "--testi-height": "300px",
                    "--testi-quantity": testimonials.length
                });
            } else {
                setStyle({
                    "--testi-width": "500px",
                    "--testi-height": "240px",
                    "--testi-quantity": testimonials.length
                });
            }
        };

        updateTransformValues();
        window.addEventListener('resize', updateTransformValues);
        return () => window.removeEventListener('resize', updateTransformValues);
    }, [width, testimonials.length])

    return (
        <div id='testimonials' className='testimonials'>
            <div className='container'>
                <h3>What Our <span>Clients </span>Say</h3>
                <p className='title'>
                    Real results, real impact—hear from those who’ve scaled with us.
                </p>
            </div>

            <div className="testi">
                {
                    width >= 810
                        ?
                        <div className='testi-slider' style={style}>
                            {/* First Slider */}
                            <div className="slider">
                                {testimonials.map((data, index) => (
                                    <div className="single-testi" style={{ "--position": (index + 1) }} key={index}>
                                        <div className="client-top">
                                            <div className="img">
                                                <img src={data.image} alt="" />
                                            </div>
                                            <div className="details">
                                                <p><b>{data.name}</b></p>
                                                <p>{data.role}</p>
                                            </div>
                                        </div>
                                        <div className="detail">
                                            <p>{data.comment}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Second Slider */}
                            <div className="slider slider-start-gap" style={style}>
                                {testimonials.map((data, index) => (
                                    <div className="single-testi" style={{ "--position": (index + 1) }} key={index}>
                                        <div className="client-top">
                                            <div className="img">
                                                <img src={data.image} alt="" />
                                            </div>
                                            <div className="details">
                                                <p><b>{data.name}</b></p>
                                                <p>{data.role}</p>
                                            </div>
                                        </div>
                                        <div className="detail">
                                            <p>{data.comment}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        :
                        <div className="container">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={40}
                                pagination={true}
                                autoplay={true}
                                breakpoints={{
                                    200: {
                                        slidesPerView: 1,
                                        spaceBetween: 40,
                                        centeredSlides: false
                                    },
                                    500: {
                                        slidesPerView: 1,
                                        spaceBetween: 40,
                                        centeredSlides: false
                                    },
                                    700: {
                                        slidesPerView: 1
                                    },
                                    810: {
                                        slidesPerView: 3,
                                    }
                                }}
                                centeredSlides={true}
                                modules={[Pagination]}
                            >
                                {[...testimonials, ...testimonials].map((data, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="single-testi">
                                            <div className="client-top">
                                                <div className="img">
                                                    <img src={data.image} alt="" />
                                                </div>
                                                <div className="details">
                                                    <p><b>{data.name}</b></p>
                                                    <p>{data.role}</p>
                                                </div>
                                            </div>
                                            <div className="detail">
                                                <p>{data.comment}</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                }
            </div>
        </div>
    );
};
